var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1473 914L1473 942",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1473.5,
    cy: 909.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.99 909.19C1468.99 905.283 1472.29 902.117 1476.36 902.117C1476.94 902.117 1477.51 902.184 1478.06 902.308C1476.74 901.48 1475.19 901 1473.52 901C1468.81 901 1465 904.806 1465 909.5C1465 914.194 1468.81 918 1473.52 918C1475.81 918 1477.89 917.093 1479.43 915.62C1478.49 916.032 1477.45 916.263 1476.36 916.263C1472.29 916.263 1468.99 913.096 1468.99 909.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.4 908.6L1482.37 906.146L1480.54 907.719L1478.3 907.056L1479.11 909.337L1477.77 911.381L1480.1 911.218L1481.5 913.144L1482.13 910.763L1484.34 909.909L1482.4 908.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.834cd60afff70ac120e4341db2944f1c.svg";
export { ForwardRef as ReactComponent };